import { useState } from 'react';
import { formatCurrency, parseCurrency } from '../lib/currency';

export function CurrencyInput({ name, defaultCents, required=false }: { name: string; defaultCents?: string | null; required?:boolean }) {
  const [value, setValue] = useState(defaultCents==null?'':formatCurrency(defaultCents));
  return <input name={name} required={required} type="text" inputMode="decimal" placeholder="$0.00" value={value}
    onChange={event => { setValue(event.target.value); event.target.setCustomValidity(''); }}
    onBlur={event => {
      try { const cents = parseCurrency(value); setValue(cents == null ? '' : formatCurrency(cents)); event.target.setCustomValidity(''); }
      catch (error) { event.target.setCustomValidity((error as Error).message); }
    }} />;
}
